import type { ReactNode } from 'react';
import { SiteFooter } from './SiteFooter';
import { SiteHeader } from './SiteHeader';

type PolicyLayoutProps = {
  eyebrow: string;
  title: string;
  updated: string;
  children: ReactNode;
};

export const PolicyLayout = ({ eyebrow, title, updated, children }: PolicyLayoutProps) => (
  <main className="min-h-screen bg-background text-foreground">
    <SiteHeader />
    <article className="mx-auto max-w-3xl px-5 pb-20 pt-12">
      <p className="text-sm font-semibold uppercase tracking-[0.18em] text-primary">{eyebrow}</p>
      <h1 className="mt-3 font-heading text-4xl font-semibold sm:text-5xl">{title}</h1>
      <p className="mt-4 text-sm text-muted">Last updated: {updated}</p>
      <div className="policy-copy mt-10">{children}</div>
    </article>
    <SiteFooter />
  </main>
);

